import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'
import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

import {colorMetadata, fontMetadata} from '../../../../../../utils/builderMetadata'

export type LocationTabsStylesParams = {
  locationTabsRegularFont: StyleParamType.Font
  locationTabsRegularColor: StyleParamType.Color
  locationTabsSelectedFont: StyleParamType.Font
  locationTabsSelectedColor: StyleParamType.Color
  locationTabsRegularDividerColor: StyleParamType.Color
  locationTabsSelectedUnderlineColor: StyleParamType.Color
}

export const locationTabsStylesParams = createStylesParams<LocationTabsStylesParams>({
  locationTabsRegularFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  locationTabsRegularColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  locationTabsSelectedFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  locationTabsSelectedColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  locationTabsRegularDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.3),
    metadata: colorMetadata(StyleType.borderColor, 'color-line', 0.3),
  },
  locationTabsSelectedUnderlineColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 1),
    metadata: colorMetadata(StyleType.borderColor, 'color-action', 1),
  },
})
